import i18n, { setCurrentLanguage } from '@/i18n';
import React, { Component } from 'react';
import './App.less';
import { Route, Switch, Redirect, BrowserRouter } from 'react-router-dom';
import AsyncComponent from './component/AsyncComponent';
import Upload from './component/CpUpload/Demo';
import 'antd-mobile-v2/dist/antd-mobile.less';
import './antd-mobile.css';
import axios from 'axios';
import enUS from 'antd-mobile/es/locales/en-US';
import zhCN from 'antd-mobile/es/locales/zh-CN';
import viVN from './locales/vi-VN';
import thTH from './locales/th-TH';
import { getCookie } from './util/getCookie';
import { ConfigProvider } from 'antd-mobile';
import { setTranlateLang, debouncedTranslate } from './util/translate';
import emitter from './util/emitter';

const BreedingCourse = AsyncComponent(() => import('./page/BreedingCourse'));
const IndustryInformation = AsyncComponent(() =>
  import('./page/IndustryInformation')
);
const IndustryInformationC = AsyncComponent(() =>
  import('./page/IndustryInformationC')
);
const CostToolsDownLoad = AsyncComponent(() =>
  import('./page/CostTools/download')
);
const AgriculturalBank = AsyncComponent(() =>
  import('./page/AgriculturalBank')
);
const PigDownLoad = AsyncComponent(() => import('./page/PigDownload'));
// const ItsActivity = AsyncComponent(() => import('./page/ItsActivity'));
const Vet = AsyncComponent(() => import('./page/Vet'));
const Piglets = AsyncComponent(() => import('./page/Piglets'));
// const PigNewDownLoad = AsyncComponent(() => import('./page/PigNewDownload'));
const DownloadTemplate = AsyncComponent(() =>
  import('./page/DownloadTemplate')
);

const AreaDirector = AsyncComponent(() =>
  import('./page/PigTrade/areaDirector')
); // 片区主管详情
const TransportManagement = AsyncComponent(() =>
  import('./page/PigTrade/transportManagement')
); // 运管详情
const RunningTrack = AsyncComponent(() =>
  import('./page/PigTrade/runningTrack')
); // 车辆运行轨迹

//猪交易详情
const PigTradeDetail = AsyncComponent(() => import('./page/PigTrade/Detail'));
//肥猪猪交易详情
const FatPigDetail = AsyncComponent(() =>
  import('./page/PigTrade/FatPigDetail')
);
//仔猪猪交易详情
const PigletDetail = AsyncComponent(() =>
  import('./page/PigTrade/PigletDetail')
);

const ApplyCooperation = AsyncComponent(() =>
  import('./page/ApplicationProcess/applyCooperation')
); // 养殖户、经销商合作申请
const MyApplication = AsyncComponent(() =>
  import('./page/ApplicationProcess/myApplication')
); // 我的申请单列表
const ApplyDetail = AsyncComponent(() =>
  import('./page/ApplicationProcess/applyDetail.js')
); // 申请单详情

// 用户注册页面
const Register = AsyncComponent(() => import('./page/Register/Index.js'));
// 由注册页面跳转的下载页面
const RegisterDownload = AsyncComponent(() =>
  import('./page/Register/RegisterDownload.js')
);
// 用户注册页面(销售员二维码分享)
const QrCodeRegister = AsyncComponent(() =>
  import('./page/Register/QRCodeShare')
);

// 申请单详情
const Finance = AsyncComponent(() => import('./page/Finance')); // 支付指导
const ServiceAgreement = AsyncComponent(() =>
  import('./page/ServiceAgreement')
); // 猪博士服务协议

// 金融详情
const FinanceHelp = AsyncComponent(() => import('./page/Finance/help')); // 支付指导

const Offer = AsyncComponent(() => import('./page/Quotation/Offer'));

// 微赞登录页面
const VzanLogin = AsyncComponent(() => import('./page/VzanLogin/Index')); // 支付指导

const ClearPage = AsyncComponent(() => import('./page/clearPage'));

const DiscountReport = AsyncComponent(() =>
  import('./page/Discount/MonthReport')
);

const LuzhouPromotion = AsyncComponent(() =>
  import('./page/Bank/Luzhou/Promotion')
);

const BOCOMGuide = AsyncComponent(() =>
  import('./page/Bank/BOCOM/guide')
);

const ChongqingGuide = AsyncComponent(() =>
  import('./page/Bank/Chongqing/guide')
);

const BOCOMLoan = AsyncComponent(() =>
  import('./page/Bank/BOCOM/loan')
);

const ABCPromotion = AsyncComponent(() => import('./page/Bank/ABC/Promotion'));

const CCBPromotion = AsyncComponent(() => import('./page/Bank/CCB/Promotion'));

//一键发布猪源
const OneClickPublish = AsyncComponent(() =>
  import('./page/PigTrade/OneClickPublish/Publish')
);
const OneClickDetail = AsyncComponent(() =>
  import('./page/PigTrade/OneClickPublish/Detail')
);

//西南区发布猪源
const SouthwestOneClickPublish = AsyncComponent(() =>
  import('./page/PigTrade/OneClickPublish/SouthwestPublish')
);

//三农活动
const AgricultureRegister = AsyncComponent(() =>
  import('./page/Activity/Agriculture/UserRegister')
);

const HanKou = AsyncComponent(() =>
  import('./page/Bank/Hankou/Index')
);

const WXRedirect = AsyncComponent(() => import('./page/WxRedirect/Index1'));
const userAgentInfo = navigator.userAgent.split(' ');
let appid = '';
userAgentInfo.forEach((item) => {
  if (item.indexOf('miniprogramhtmlwebview') !== -1) {
    appid = '30';
  }
  if (item.indexOf('appName/') !== -1) {
    const spart = item.split('/');
    if (spart[1] === 'ZDClient') {
      appid = '1';
    }
    if (spart[1] === i18n.t('CP Staff')) {
      appid = '2';
    }
  }
  if (item.indexOf('IOrder') !== -1) {
    appid = '1';
  }
  if (item.indexOf('IFarm') !== -1) {
    appid = '2';
  }
});
axios.defaults.headers['appid'] = appid;

//TODO: 项目扩大，路由可以更改为配置化
class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      locale: zhCN,
      lang: 'zh',
    };
  }
  componentDidMount() {
    const lang = getCookie('lang');
    const translate = getCookie('translate');
    this.setState({ lang });
    if (lang !== 'zh') {
      if (lang === 'en') {
        this.setState({ locale: enUS });
      } else if (lang === 'vi') {
        this.setState({ locale: viVN });
      } else if (lang === 'th') {
        this.setState({ locale: thTH });
      }
      setCurrentLanguage(lang);
      if (translate && translate === 'true') {
        setTranlateLang(lang);
      }
    }
    emitter.addListener('nativeMessage', (val) => {
      const { type, data } = val;
      if (type === 'translate') {
        if (data.translate === 'true') {
          setTranlateLang(lang);
          debouncedTranslate();
        } else {
          document.cookie = 'translate=false';
          window.location.reload();
        }
      }
    });
  }
  render() {
    const pathname = (window.location.pathname || '').toLowerCase();
    return (
      <ConfigProvider locale={this.state.locale}>
        <div className={`App ${this.state.lang !== 'zh' ? 'locale-layout' : ''}`}>
          <BrowserRouter>
            <Switch>
              <Route
                path="/"
                exact
                render={() => <Redirect to="breedingCourse" />}
              />

              <Route path="/breedingCourse" component={BreedingCourse} />
              <Route
                path="/industryInformation"
                component={IndustryInformation}
              />

              <Route path="/temp" component={IndustryInformationC} />

              <Route path="/costToolsDownload" component={CostToolsDownLoad} />
              <Route path="/agriculturalBank" component={AgriculturalBank} />
              <Route path="/pigdownload" component={PigDownLoad} />

              <Route path="/vet" component={Vet} />
              <Route path="/piglets" component={Piglets} />

              <Route path="/downloadtemplate" component={DownloadTemplate} />
              <Route path="/areadirector" component={AreaDirector} />
              <Route
                path="/transportmanagement"
                component={TransportManagement}
              />

              <Route path="/register" component={Register} exact />
              <Route path="/register/qrcode" component={QrCodeRegister} />
              <Route path="/register/download" component={RegisterDownload} />
              <Route path="/runningTrack" component={RunningTrack} />
              <Route path="/applycooperation" component={ApplyCooperation} />
              <Route path="/myApplication" component={MyApplication} />
              <Route path="/applyDetail" component={ApplyDetail} />
              <Route path="/upload" component={Upload} />
              <Route path="/finance" exact component={Finance} />
              <Route path="/finance/help" component={FinanceHelp} />

              <Route path="/service/agreement" component={ServiceAgreement} />
              <Route path="/pigtrade/detail/:id" component={PigTradeDetail} />
              <Route path="/fatpigtrade/detail/:id" component={FatPigDetail} />
              <Route path="/piglettrade/detail/:id" component={PigletDetail} />
              <Route path="/quotation/offer" component={Offer} />
              <Route path="/vzan/login" component={VzanLogin} />
              <Route path="/token/clear" component={ClearPage} />
              <Route path="/discount/report" component={DiscountReport} />
              <Route
                path="/bank/luzhou/promotion"
                component={LuzhouPromotion}
              />
               <Route
                path="/bank/bocom/guide"
                component={BOCOMGuide}
              />
               <Route
                path="/bank/bocom/loan"
                component={BOCOMLoan}
              />
               <Route
                path="/bank/chongqing/guide"
                component={ChongqingGuide}
              />
              
               <Route
                path="/bank/hankou"
                component={HanKou}
              />
              <Route path="/bank/abc/promotion" component={ABCPromotion} />
              <Route path="/bank/ccb/promotion" component={CCBPromotion} />

              <Route
                path="/pigtrade/oneclick/publish"
                component={OneClickPublish}
              />
              <Route
                path="/pigtrade/oneclick/southwest/publish"
                component={SouthwestOneClickPublish}
              />
              <Route
                path="/pigtrade/oneclick/detail"
                component={OneClickDetail}
              />

              <Route
                path="/agriculture/register"
                component={AgricultureRegister}
              />
            </Switch>
          </BrowserRouter>
          {
            //避免native获取元素造成异常（因native相关代码涉及页面较多时间较长，使用降级方案）
            pathname.indexOf('/industryinformation') === -1 ? (
              <div
                id="content"
                style={{
                  display: 'none',
                }}
              />
            ) : (
              <></>
            )
          }
        </div>
      </ConfigProvider>
    );
  }
}
export default App;

{
  /* <Route path="/pignewdownload" component={PigNewDownLoad} /> */
}
{
  /* <Route path="/payActivity" component={PayActivity} /> */
}
{
  /* <Route path="/itsActivity" component={ItsActivity} /> */
}
{
  /* <Route path="/landingpage" component={LandingPage} /> */
}
